import { useEffect, useState } from "react";
import { ReactComponent as DownloadIcon } from "../../../assets/icons/NewIcons/IconDownload.svg";
import { ReactComponent as CrossIcon } from "../../../assets/icons/NewIcons/exitIcon.svg";
import certificateImg from "../../../assets/images/QualifiedTemplate.jpg"; // Larger certificate image
import ShareCertiWithSocialmedia from "../ShareCertiWithSocialmedia";
import DownloadCertificateMenu from "../DownloadCertificate/DownloadCertificateMenu";
import "./QualifiedCertificate.scss";

const QualifiedCertificate = ({
  data,
  publicShareTrue = false,
  image = false,
}) => {
  const certificate = data;
  const [open, setOpen] = useState(false);
  const [selectedCertificate, setSelectedCertificate] = useState(
    publicShareTrue ? data : null
  );
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleOpen = (certificate) => {
    setSelectedCertificate(certificate);
    setOpen(true);
    setImageLoaded(false);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedCertificate(null);
  };

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);
  return (
    <>
      {!publicShareTrue && (
        <div className="qualifiedcertificateSmallerContainer">
          <div className="certificateSmallerWrapper">
            <div key={certificate.id} className="small_certificate_container">
              <div className="topSection">
                <DownloadCertificateMenu
                  name={certificate?.name}
                  icon={<DownloadIcon />}
                  // The artwork only exists inside the modal, so open it first.
                  onBeforeDownload={() => handleOpen(certificate)}
                />
                <div className="certificateTitle">
                  <h3 className="certificate_title">{certificate?.title}</h3>
                </div>
              </div>
              <div
                className={`certificateImgContainer ${image ? "phase1certificateImg" : ""
                  }`}
              >
                <img
                  src={certificateImg} // Display small certificate image
                  alt="Certificate"
                  className="small_certificate_image"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleOpen(certificate)} // Open the larger certificate on click
                />
                <div className="small_certificate_name">
                  {certificate?.name}
                </div>
                <div className="small_certificate_date">
                  {certificate?.created_at}
                </div>
              </div>
              <div
                className="frame-btn-container"
                style={{ marginTop: "10px", textAlign: "center" }}
              >
                <a
                  href="https://fundedaward.com/capital"
                  target="_blank"
                  rel="noreferrer"
                  className="frame-certificate-btn"
                >
                  Frame Certificate
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      {(open || publicShareTrue) && (
        <div
          className={`${publicShareTrue ? "stage1certificateCardOverlayShare" : ""
            } qualifiedoverlayFundedCertificateContainer`}
          onClick={handleClose}
        >
          <div
            className="mainWrapperFundedCertificate certificateCardContainer"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="containerFundedCertificate">
              <div className="fundedCertificateDetails">
                <div className="leftSectionDetails certificatePopModalHeader">
                  <div className="topSection">
                    <div className="titleSection">
                      <p>{certificate?.title}</p>
                    </div>
                  </div>
                  <div className="bottomSection">
                    {" "}
                    <DownloadCertificateMenu
                      name={selectedCertificate?.name}
                      icon={<DownloadIcon />}
                    />
                    {!publicShareTrue && (
                      <div className="rightSection">
                        <div style={{ display: "flex", gap: "10px" }}>
                          <ShareCertiWithSocialmedia
                            data={selectedCertificate}
                          />
                          <div className="rightSectionDetails">
                            <div className="crossbtn" onClick={handleClose}>
                              <CrossIcon />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div
                className={`imgContainerDiv ${image ? "phase1ContainerDiv" : ""
                  }`}
                id="certificateContainer"
              >
                <img
                  src={certificateImg} // Display small certificate image
                  alt="Certificate"
                  className="certificate_image"
                  style={{ cursor: "pointer" }}
                  onLoad={() => setImageLoaded(true)}
                />
                {imageLoaded && (
                  <>
                    <p className="large_certificate_name">
                      {selectedCertificate?.name}
                    </p>
                    <p className="large_certificate_date">
                      {selectedCertificate?.created_at}
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default QualifiedCertificate;
